export interface Remarks{
    remark:string;
}

export const defaultRemarks:Remarks = {
    remark:""
}